export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const SELECTED_CUSTOMER_KEY = 'selectedCustomer';

const readToken = (key) => {
    const rawValue = localStorage.getItem(key);

    if (!rawValue) {
        return {token: '', invalid: false};
    }

    try {
        const parsedValue = JSON.parse(rawValue);
        return typeof parsedValue === 'string' && parsedValue
            ? {token: parsedValue, invalid: false}
            : {token: '', invalid: true};
    } catch (error) {
        return {token: '', invalid: true};
    }
};

export const clearStoredAuth = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(SELECTED_CUSTOMER_KEY);
};

export const readStoredAuthTokens = () => {
    const accessTokenResult = readToken(ACCESS_TOKEN_KEY);
    const refreshTokenResult = readToken(REFRESH_TOKEN_KEY);
    const invalid = accessTokenResult.invalid || refreshTokenResult.invalid;

    if (invalid) {
        clearStoredAuth();
    }

    return {
        accessToken: invalid ? '' : accessTokenResult.token,
        refreshToken: invalid ? '' : refreshTokenResult.token,
        invalid,
    };
};

export const getStoredAccessToken = () => readStoredAuthTokens().accessToken;

export const persistAuthTokens = ({accessToken, refreshToken}) => {
    if (accessToken) {
        localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(accessToken));
    } else {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
    }

    if (refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, JSON.stringify(refreshToken));
    } else {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
};
